export default "__VITE_ASSET__71d66861__"